import KenBurns from "../global/KenBurns";
import Section from "../Section";

export default class AnimatedText extends Section {
  constructor(theme, element, pageLoad) {
    super(theme, element, pageLoad);

    this.kenBurns = new KenBurns(theme, element);
  }
}
